import { Tooltip } from '@material-ui/core';
import NotificationDrawer from 'components/Notifications/Drawer';
import { StyledPrimaryButton } from 'containers/NavBarDashboard/styles';
import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getNotifications } from 'store/user/actions';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'helpers/intl';
import messages from 'components/Notifications/messages';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const NotificationButton = (props: { intl: IntlShape }) => {
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);
  const dispatch = useDispatch();
  return (
    <StyledPrimaryButton variant="contained">
      <Tooltip title={translate(get(messages, 'notifications'), props)}>
        <GaClickHOC
          label="Notifications"
          category={EVENT_CATEGORIES.NOTIFICATIONS}
        >
          <img
            data-testid="notification-button"
            onClick={() => {
              dispatch(getNotifications());
              setIsOpen(!isOpen);
            }}
            src={get(AssuranceIcon, 'bell')}
            alt="bell-icon"
          />
        </GaClickHOC>
      </Tooltip>
      <NotificationDrawer isOpen={isOpen} close={close} />
    </StyledPrimaryButton>
  );
};

export default injectIntl(NotificationButton);
